// @ts-check

import {
  isSameDay,
  differenceInDays,
  isYesterday,
  isToday,
  endOfMonth,
  startOfWeek,
  startOfMonth,
  startOfYear,
  subMonths,
  subWeeks,
  endOfWeek,
} from "date-fns";

const TODAY = new Date();

export const dateRangeTypeToWords = (dateRange) => {
  switch (dateRange) {
    case "today": return "Today";
    case "yesterday": return "Yesterday";
    case "lastSevenDays": return "Last 7 days";
    case "lastFourteenDays": return "Last 14 days";
    case "lastThirtyDays": return "Last 30 days";
    case "lastNinetyDays": return "Last 90 days";
    case "weekToDate": return "Week to date";
    case "monthToDate": return "Month to date";
    case "custom":
    default: return "Custom range";
  }
};

export const calculateCurrentDatePeriodType = (dates) => {
  if (
    isSameDay(dates.start, dates.end) &&
    isToday(dates.start)
  ) {
    return "today";
  }

  if (
    isSameDay(dates.start, dates.end) &&
    isYesterday(dates.start)
  ) {
    return "yesterday";
  }

  if (
    Math.abs(differenceInDays(dates.start, dates.end)) === 6 &&
    isToday(dates.end)
  ) {
    return "lastSevenDays";
  }

  if (
    Math.abs(differenceInDays(dates.start, dates.end)) === 13 &&
    isToday(dates.end)
  ) {
    return "lastFourteenDays";
  }

  if (
    Math.abs(differenceInDays(dates.start, dates.end)) === 29 &&
    isToday(dates.end)
  ) {
    return "lastThirtyDays";
  }

  if (
    Math.abs(differenceInDays(dates.start, dates.end)) === 89 &&
    isToday(dates.end)
  ) {
    return "lastNinetyDays";
  }

  if (
    isSameDay(dates.start, startOfWeek(TODAY)) &&
    isToday(dates.end)
  ) {
    return "weekToDate";
  }

  if (
    isSameDay(dates.start, startOfMonth(TODAY)) &&
    isToday(dates.end)
  ) {
    return "monthToDate";
  }

  if (
    isSameDay(dates.start, startOfYear(TODAY)) &&
    isToday(dates.end)
  ) {
    return "yearToDate";
  }

  if (
    isSameDay(dates.start, startOfWeek(subWeeks(TODAY, 1))) &&
    isSameDay(dates.end, endOfWeek(subWeeks(TODAY, 1)))
  ) {
    return "lastWeek";
  }

  if (
    isSameDay(dates.start, startOfMonth(subMonths(TODAY, 1))) &&
    isSameDay(dates.end, endOfMonth(subMonths(TODAY, 1)))
  ) {
    return "lastMonth";
  }

  return "custom";
};
